'use client';

import React from 'react';

import { TasticProps } from 'frontastic/tastics/types';
import  {ExperienceCenterLocationSpecificProps} from 'components/commercetools-ui/organisms/experience-center/location-specific';
import ExperienceCenterLandingPage from 'components/commercetools-ui/organisms/experience-center';


const ExperienceCenterTastic  = ({ data }: TasticProps<ExperienceCenterLocationSpecificProps>) => {
  return <ExperienceCenterLandingPage data={data?.data?.dataSource} />;
};

export default ExperienceCenterTastic;